import { formatBirthDateToString } from 'ui';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { DeliveryData, InfoData, PersonalData } from '../types';
import { imperialUnits } from '../utils';
import type { SubscribeDataObject } from './data-objects';

export const subscribe = async ({
  deliveryData,
  infoData,
  personalData,
  programId,
}: {
  deliveryData: DeliveryData;
  infoData: InfoData;
  personalData: PersonalData;
  programId: string;
}) => {
  const shortname = `${personalData.firstName + personalData.lastName}111`
    .normalize('NFD')
    // eslint-disable-next-line unicorn/prefer-string-replace-all -- Linter is not working correctly, will cause TS error
    .replace(/[\u0300-\u036F]/g, '')
    .toUpperCase()
    .slice(0, 3);

  /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
  const data = {
    order: {
      birthdate: formatBirthDateToString(personalData.birthdate),
      email: deliveryData.email,
      firstname: personalData.firstName.trim(),
      gender: personalData.gender === 'male' ? 0 : 1,
      lastname: personalData.lastName.trim(),
      mailingpref: Boolean(infoData.marketing),
      measures: [
        {
          type: 4,
          unit: -2,
          value: imperialUnits.units.height.convertToDefault(personalData.heightInImperial),
        },
        {
          type: 1,
          unit: 0,
          value: imperialUnits.units.weight.convertToDefault(personalData.weightInImperial),
        },
      ],
      order: {
        address: {
          address1: deliveryData.address1.trim(),
          address2: deliveryData.address2.trim(),
          city: deliveryData.city.trim(),
          country: deliveryData.country,
          email: deliveryData.email,
          name: `${deliveryData.firstName} ${deliveryData.lastName}`.trim(),
          state: deliveryData.state,
          telephone: deliveryData.phone,
          zip: deliveryData.zip.trim(),
        },
      },
      preflang: personalData.prefferedLanguage,
      program_id: programId,
      shortname: shortname.trim(),
      timezone: personalData.prefferedTimezone,
      unit_pref: {
        distance: 6,
        height: 6,
        temperature: 11,
        weight: 1,
      },
    },
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

  return apiClient.post<SubscribeDataObject, ApiClientResponse<SubscribeDataObject>>(routes.withings.subscribe, data);
};
